/**
 * InvoicePaymentMethods Component
 */

import { getCountryLabelFromCode, getStateLabelFromCode } from '../../../../redux/helpers/countries';
import { formatAddress } from '../../../../utils/address';
import { Currency } from '../../../../utils/money';
import { nl2br } from '../../../../utils/react';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';

import Heading from '../../../atoms/text/Heading';
import { Paragraph, Span } from '../../../atoms/text/Label';

interface IOwnStateProps {
  businessInformation: GQL.IBusinessInformation;
  getCountryLabel(countryCode: string): string | undefined;
  getStateLabel(stateCode: string): string | undefined;
}

interface IOwnProps {
  currency: GQL.Currency;
}

type InvoicePaymentMethodsProps = IOwnStateProps & IOwnProps;

const classes = new BEM('invoice__payment-methods');

class InvoicePaymentMethods extends React.Component<InvoicePaymentMethodsProps, any> {

  renderBankTransferInformation(currency?: GQL.Currency) {
    if (!currency) {
      switch (this.props.currency as any) {
        case Currency.CAD:
          return this.renderBankTransferInformation(this.props.currency);
        default:
          return this.renderBankTransferInformation(Currency.USD as any);
      }
    }

    const {
      businessInformation: {
        commercial_details: {
          financial_institution,
          bank_accounts,
        },
      },
      getCountryLabel,
      getStateLabel,
    } = this.props;

    const bankAccount = bank_accounts!.find((acc) => acc!.currency === currency)!;

    return (
      <>
        <Heading is="h6">Bank Transfer</Heading>
        <Paragraph variant="description" size="large">
          Please include in description field:<br />
          <em>Beneficiary account in {currency} funds</em>
        </Paragraph>
        <Paragraph size="small" {...classes('item__information')}>
          <strong>{financial_institution.company}</strong><br />
          {nl2br(formatAddress(financial_institution, getCountryLabel, getStateLabel, true))}<br />
          SWIFT Code: {bankAccount.swift_code}<br />
          Branch ID: {bankAccount.branch_id}<br />
          Account Number: {bankAccount.account_number}
        </Paragraph>
      </>
    );
  }

  render() {
    const {
      businessInformation: {
        name,
        legal_name: legalName,
        address,
      },
      getCountryLabel,
      getStateLabel,
    } = this.props;
    return (
      <section {...classes()}>
        <div {...classes('header')}>
          <Heading is="h4" {...classes('title')}>Payment methods</Heading>
          <Span size="large" variant="description">Payment must be received within 30 days of invoice date.</Span>
        </div>
        <div {...classes('item')}>
          {this.renderBankTransferInformation()}
        </div>
        {renderChequePaymentInformation({
          address, legalName, name, getCountryLabel, getStateLabel, includeHeading: true,
        })}
      </section>
    );
  }
}

export interface IRenderChequePaymentInformationOptions {
  includeHeading: boolean;
  address: GQL.IAddress;
  legalName: string;
  name: string;
  getCountryLabel(countryCode: string): string | undefined;
  getStateLabel(stateCode: string): string | undefined;
}

export function renderChequePaymentInformation(options: IRenderChequePaymentInformationOptions) {
  const {
    includeHeading,
    address,
    legalName,
    name,
    getCountryLabel,
    getStateLabel,
  } = options;
  return (
    <div {...classes('item')}>
      {includeHeading ? <Heading is="h6">Cheque</Heading> : ''}
      <Paragraph variant="description" size="large">
        Please make your cheque payable to {name} and allow at least five business days for processing.
      </Paragraph>
      <Paragraph size="small" {...classes('item__information')}>
        <strong>All cheques must be sent to:</strong><br /><br />
        {legalName}<br />
        {nl2br(formatAddress(address, getCountryLabel, getStateLabel, true))}
      </Paragraph>
    </div>
  );
}

const ConnectedInvoicePaymentMethods = connect<IOwnStateProps, {}, IOwnProps, IStoreState>(
  (state) => ({
    businessInformation: state.staticData.businessInformation as GQL.IBusinessInformation,
    getCountryLabel: (countryCode) => getCountryLabelFromCode(countryCode)(state),
    getStateLabel: (stateCode) => getStateLabelFromCode(stateCode)(state),
  }),
)(InvoicePaymentMethods);

export default ConnectedInvoicePaymentMethods;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/account/Invoice/InvoicePaymentMethods.tsx